import { render, staticRenderFns } from "./Balls.vue?vue&type=template&id=05b1d8c0&"
import script from "./Balls.vue?vue&type=script&lang=js&"
export * from "./Balls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports